import { SelectOption } from './select-options.util';

const CANADIAN_PROVINCES = ["AB","BC","MB","NB","NL","NS","NT","NU","ON","PE","QC","SK","YT"];

export function filterProvinceOptions(filterString: string, allOptions: SelectOption[]): SelectOption[] {
  if (!allOptions) {
    return [];
  }
  switch (filterString) {
    case "CA":
      return allOptions.filter(option => CANADIAN_PROVINCES.includes(option.value));
    case "US":
      return allOptions.filter(option => !CANADIAN_PROVINCES.includes(option.value));
    default:
      return allOptions;
  }
}
